import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../../chunks/tslib.es6.js";
import "../../core/has.js";
import o from "../../core/Logger.js";
import { init as i } from "../../core/watchUtils.js";
import { property as e } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as s } from "../../core/accessorSupport/decorators/subclass.js";
import r from "./Component.js";
import n from "./UI.js";
import a from "../../widgets/Attribution.js";
import d from "../../widgets/Compass.js";
import p from "../../widgets/NavigationToggle.js";
import c from "../../widgets/Zoom.js";
var m = "esri.views.ui.DefaultUI";

function h(t) {
  return t && void 0 !== t.view;
}

o.getLogger(m);

var g = /*#__PURE__*/function (_n) {
  _inherits(g, _n);

  var _super = _createSuper(g);

  function g(t) {
    var _this;

    _classCallCheck(this, g);

    _this = _super.call(this, t), _this._defaultPositionLookup = {
      attribution: "manual",
      compass: "top-leading",
      "navigation-toggle": "top-leading",
      zoom: "top-leading"
    }, _this.components = [];
    return _this;
  }

  _createClass(g, [{
    key: "initialize",
    value: function initialize() {
      this._handles.add([i(this, "components", this._componentsWatcher.bind(this)), i(this, "view", this._updateViewAwareWidgets.bind(this))]);
    }
  }, {
    key: "_add",
    value: function _add(t, o, i, e) {
      if ("string" == typeof t && this._defaultPositionLookup[t]) {
        if (this._find(t)) return;
        t = this._createComponent(t);
      }

      _get(_getPrototypeOf(g.prototype), "_add", this).call(this, t, o, i, e);
    }
  }, {
    key: "_removeComponents",
    value: function _removeComponents(t) {
      var _this2 = this;

      t.forEach(function (t) {
        var o = _this2._find(t);

        o && (_this2.remove(o), o.destroy());
      });
    }
  }, {
    key: "_updateViewAwareWidgets",
    value: function _updateViewAwareWidgets(t) {
      var _this3 = this;

      this.components.forEach(function (o) {
        var i = _this3._find(o),
            e = i && i.widget;

        h(e) && (e.view = t);
      });
    }
  }, {
    key: "_componentsWatcher",
    value: function _componentsWatcher(t, o) {
      this._removeComponents(o), this._addComponents(t), this._adjustPadding(t);
    }
  }, {
    key: "_adjustPadding",
    value: function _adjustPadding(t) {
      if (-1 === t.indexOf("attribution") && !this._isOverridden("padding")) {
        var _t = this.padding.top;
        this.padding = _t;
      }
    }
  }, {
    key: "_addComponents",
    value: function _addComponents(t) {
      var _this4 = this;

      this.initialized && t.forEach(function (t) {
        return _this4.add(_this4._createComponent(t), _this4._defaultPositionLookup[t]);
      });
    }
  }, {
    key: "_createComponent",
    value: function _createComponent(t) {
      var o = this._createWidget(t);

      if (o) return new r({
        id: t,
        node: o
      });
    }
  }, {
    key: "_createWidget",
    value: function _createWidget(t) {
      return "attribution" === t ? this._createAttribution() : "compass" === t ? this._createCompass() : "navigation-toggle" === t ? this._createNavigationToggle() : "zoom" === t ? this._createZoom() : void 0;
    }
  }, {
    key: "_createAttribution",
    value: function _createAttribution() {
      return new a({
        view: this.view
      });
    }
  }, {
    key: "_createCompass",
    value: function _createCompass() {
      return new d({
        view: this.view
      });
    }
  }, {
    key: "_createNavigationToggle",
    value: function _createNavigationToggle() {
      return new p({
        view: this.view
      });
    }
  }, {
    key: "_createZoom",
    value: function _createZoom() {
      return new c({
        view: this.view
      });
    }
  }]);

  return g;
}(n);

t([e()], g.prototype, "components", void 0), g = t([s(m)], g);
var u = g;
export { u as default };